import React from "react";

class Footer extends React.Component {
  componentWillMount() {
  }
  render() {
    return (
      <div>
        <footer className="cpoy-right-bg">
          <div className="container">
            <div className="row">
              <div className="col-md-12 text-center">
                <div className="social-footer">
                  <ul>
                    <li>
                      <a
                        href="mailto:john@illpackus.com" target="_top" rel="noopener noreferrer"
                        dangerouslySetInnerHTML={{
                          __html:
                            '<i class="fa fa-envelope" aria-hidden="true"></i>'
                        }}
                      />
                    </li>
                    <li>
                      <a
                        href="https://twitter.com/illpackus" target="_blank" rel="noopener noreferrer"
                        dangerouslySetInnerHTML={{
                          __html:
                            '<i class="fa fa-twitter" aria-hidden="true"></i>'
                        }}
                      />
                    </li>
                    <li>
                      <a
                        href="https://instagram.com/illpackus" target="_blank" rel="noopener noreferrer"
                        dangerouslySetInnerHTML={{
                          __html:
                            '<i class="fa fa-instagram" aria-hidden="true"></i>'
                        }}
                      />
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-md-12 text-center">
                <p className="copyright">
                  © 2018-2019 I'll Pack Us
                </p>
              </div>
            </div>
          </div>
        </footer>
      </div>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/footer.js